module.exports = __webpack_public_path__ + "img/verkleidung.8757e578.webp";